import { render, staticRenderFns } from "./submitTypingSuccess.vue?vue&type=template&id=5928ccf8&scoped=true&"
import script from "./submitTypingSuccess.vue?vue&type=script&lang=js&"
export * from "./submitTypingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./submitTypingSuccess.vue?vue&type=style&index=0&id=5928ccf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928ccf8",
  null
  
)

export default component.exports